import React from 'react'
import { markupAndSanitize } from '@utils/sanitize'

interface MarkdownRendererProps {
  value?: string
  onClick?: () => void
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> & { RENDERER_TYPE: string } = props => {
  const { value, onClick } = props

  const handleClick = (_e: React.MouseEvent<HTMLSpanElement>) => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <span className="content-renderer content-renderer--markdown markdown-renderer" title={value} onClick={handleClick}>
      <span className="marked-up" dangerouslySetInnerHTML={{ __html: markupAndSanitize(value) }} />
    </span>
  )
}

MarkdownRenderer.RENDERER_TYPE = 'markdown'

export default MarkdownRenderer
